var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_vm._v(" Left Bar default ")])
}
var staticRenderFns = []

export { render, staticRenderFns }